/**
 * 表示ラベル・書式の純粋ロジック
 *
 * @graph-stack creative
 * @graph-domain Marketing
 * @graph-business Design Guide の判定レベル・カラーグループ・プロンプトカテゴリ等の表示ラベルと日時整形。
 * @graph-connects none
 */
import type {
  ColorGroup,
  DeviationLevel,
  JudgmentLevel,
  PrincipleColorKey,
  PromptCategory,
} from '@cortex/domain-creative/web';

/** 逸脱時判定レベルの表示ラベル。 @graph-connects none */
export const DEVIATION_LABELS: Record<DeviationLevel, string> = {
  ng: 'NG',
  caution: '注意',
};

/** 判定 3 段階の表示ラベル。 @graph-connects none */
export const JUDGMENT_LABELS: Record<JudgmentLevel, string> = {
  ng: 'NG',
  caution: '注意',
  ok: 'OK',
};

/** カラーグループの表示ラベル。 @graph-connects none */
export const COLOR_GROUP_LABELS: Record<ColorGroup, string> = {
  semantic: 'Semantic',
  primitive: 'Primitive',
  brand_identity: 'Brand Identity',
};

/** プロンプトカテゴリの表示ラベル。 @graph-connects none */
export const PROMPT_CATEGORY_LABELS: Record<PromptCategory, string> = {
  review: 'レビュー',
  generation: '制作',
  behavior: '振る舞い',
};

/**
 * プリンシパルの表示色キーを CSS 変数名に解決する。
 * @param colorKey プリンシパルの colorKey
 * @returns テーマ CSS 変数名
 * @graph-connects none
 */
export function principleColorVar(colorKey: PrincipleColorKey): string {
  // accent はテキスト用途のため Decoration 色 (#C8963D) そのものではなく accent-text を使う
  // (ガイド「Decoration はテキスト使用NG」への自己準拠)
  const vars: Record<PrincipleColorKey, string> = {
    accent: '--dh-accent-text',
    blue: '--dh-blue',
    green: '--dh-green',
    pink: '--dh-pink',
  };
  return vars[colorKey];
}

/**
 * ISO 日時文字列を日本語ロケールの表示用文字列に整形する。parse 不能なら原文を返す。
 * @param iso ISO8601 文字列
 * @returns `2026/07/16 12:34` 形式の文字列
 * @graph-connects none
 */
export function formatDateTime(iso: string): string {
  const ms = Date.parse(iso);
  if (Number.isNaN(ms)) {
    return iso;
  }
  const date = new Date(ms);
  const pad = (value: number): string => String(value).padStart(2, '0');
  return `${String(date.getFullYear())}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
